import { Injectable, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserPreferencesActions } from './user-preferences.actions';
import { AppTheme } from './user-preferences.model';
import { UserPreferencesFeature } from './user-preferences.feature';

@Injectable({ providedIn: 'root' })
export class UserPreferencesFacade {
  private store = inject(Store);

  readonly theme = this.store.selectSignal(UserPreferencesFeature.selectTheme);
  readonly isLightTheme = computed(() => this.theme() === AppTheme.LIGHT);
  readonly isDarkTheme = computed(() => this.theme() === AppTheme.DARK);

  toggleTheme(): void {
    this.store.dispatch(UserPreferencesActions.toggleThemePreference());
  }
}
